import { render } from "./selectLanguage.vue?vue&type=template&id=d9995d36&scoped=true"
import script from "./selectLanguage.vue?vue&type=script&lang=js"
export * from "./selectLanguage.vue?vue&type=script&lang=js"

import "./selectLanguage.vue?vue&type=style&index=0&id=d9995d36&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9995d36"]])

export default __exports__